export default __webpack_public_path__ + "static/media/computer-2.7a1d0b15.svg";